<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="app-modal-container" :style="containerStyle">
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    containerStyle: {
      type: Object,
      default: () => ({ width: '100%' })
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.app-modal-container {
  background-color: #21202C;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: 0px auto;
  padding: 30px 30px;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  .my-modal-content {
    font-family: 'geomanist-book';
    width: 1140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .modal-text {
      padding-bottom: 8px;
      color: white;
      font-size: 1.25rem;
    }
  }
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.close-button {
  cursor: pointer;
  position: relative;
  left: 1140px;
  top: 10px;
  width: 20px;
  height: 22px;
  border: none;
  background-size: 20px;
  background-repeat: no-repeat;  background-image: url('../assets/icons/cross-big.svg');
  margin: 0px;
}

</style>
